/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Blank_HintInputs */

const en_us2_workout_blank_hint = /** @type {(inputs: Workout_Blank_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You choose the exercises as you go.`)
};

const pt_br2_workout_blank_hint = /** @type {(inputs: Workout_Blank_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você escolhe os exercícios na hora.`)
};

const es_419_workout_blank_hint = /** @type {(inputs: Workout_Blank_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliges los ejercicios sobre la marcha.`)
};

const pt_pt2_workout_blank_hint = /** @type {(inputs: Workout_Blank_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhes os exercícios na hora.`)
};

const fr_fr2_workout_blank_hint = /** @type {(inputs: Workout_Blank_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu choisis les exercices au fur et à mesure.`)
};

const de_de2_workout_blank_hint = /** @type {(inputs: Workout_Blank_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du wählst die Übungen unterwegs.`)
};

const it_it2_workout_blank_hint = /** @type {(inputs: Workout_Blank_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli gli esercizi strada facendo.`)
};

/**
* | output |
* | --- |
* | "You choose the exercises as you go." |
*
* @param {Workout_Blank_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_blank_hint = /** @type {((inputs?: Workout_Blank_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Blank_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_blank_hint(inputs)
	if (locale === "es-419") return es_419_workout_blank_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_blank_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_blank_hint(inputs)
	if (locale === "de-DE") return de_de2_workout_blank_hint(inputs)
	if (locale === "it-IT") return it_it2_workout_blank_hint(inputs)
	return en_us2_workout_blank_hint(inputs)
});
export { workout_blank_hint as "workout.blank_hint" }